export const transformBrowserAttributesModel = _ref => {
  let {
    language,
    colorDepth,
    javaEnabled,
    screenWidth,
    screenHeight,
    timezoneOffset
  } = _ref;
  return {
    language,
    color_depth: colorDepth,
    java_enabled: javaEnabled,
    screen_height: screenHeight,
    screen_width: screenWidth,
    timezone_offset: timezoneOffset
  };
};